import React, { useEffect, useState } from "react";
import "./index.css";
import { IconButton } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../stores/store";
import {
  selectSelectedCollection,
  setPaginationModel,
} from "../../stores/collection";
import CollectionDetail from "../../components/CollectionDetail";
import { useNavigate } from "react-router";
import { ROUTES } from "../../config/routes";
import { ArrowBack } from "@mui/icons-material";
import { clearCurrentSpecimen } from "../../stores/specimens";
import _ from "lodash";
import { fetchCollections } from "../../stores/collection/actions";
import { useWebServer } from "../../providers";

const Collections: React.FC = () => {
  const [curIndex, setCurIndex] = useState<number>(0);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { sendRequest } = useWebServer();
  const collection = useAppSelector(selectSelectedCollection);
  const collections = useAppSelector((state) => state.collections.collections);
  const collectionCount = useAppSelector((state) => state.collections.count);
  const paginationModel = useAppSelector(
    (state) => state.collections.paginationModel
  );
  const formData = useAppSelector((state) => state.collections.formData);

  useEffect(() => {
    const curIndex = _.findIndex(collections, collection);
    setCurIndex(curIndex);
    const fetchedPage = collections.length / paginationModel.pageSize - 1;
    const curPage = Math.floor(curIndex / paginationModel.pageSize);
    const nextPage = curPage + 1;
    if (nextPage > fetchedPage && collections.length < collectionCount) {
      dispatch(
        fetchCollections({
          sendRequest,
          filters: {
            ...formData,
            page: nextPage,
            pageSize: paginationModel.pageSize,
          },
        })
      );
      dispatch(
        setPaginationModel({
          page: curPage,
          pageSize: paginationModel.pageSize,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collection]);

  useEffect(() => {
    if (collection.displayName === "") {
      navigate(ROUTES.HOME);
    }
    dispatch(clearCurrentSpecimen());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="block-collection-detail">
      <div className="btn-go-back-collections">
        <IconButton>
          <ArrowBack
            color="primary"
            onClick={() => {
              navigate(ROUTES.HOME);
            }}
          />
        </IconButton>
      </div>

      <CollectionDetail
        collection={collection}
        goToCollection={() => {
          navigate(ROUTES.SPECIMENGALLERY);
        }}
        curIndex={curIndex}
        collectionCount={collectionCount}
      />
    </div>
  );
};

export default Collections;
